export enum AccountDataActions {
  NEXT_STEP,
}
